var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "loginForm",
      staticClass: "login-form",
      attrs: { model: _vm.loginForm, "status-icon": "", "label-width": "0" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "username" } },
        [
          _c(
            "el-input",
            {
              attrs: {
                size: "small",
                "auto-complete": "off",
                placeholder: "请输入用户名",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
              model: {
                value: _vm.loginForm.username,
                callback: function ($$v) {
                  _vm.$set(_vm.loginForm, "username", $$v)
                },
                expression: "loginForm.username",
              },
            },
            [
              _c("i", {
                staticClass: "icon-login",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "password" } },
        [
          _c(
            "el-input",
            {
              attrs: {
                type: _vm.passwordType,
                size: "small",
                "auto-complete": "off",
                placeholder: "请输入密码",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
              model: {
                value: _vm.loginForm.password,
                callback: function ($$v) {
                  _vm.$set(_vm.loginForm, "password", $$v)
                },
                expression: "loginForm.password",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-view el-input__icon",
                attrs: { slot: "suffix" },
                on: { click: _vm.showPassword },
                slot: "suffix",
              }),
              _c("i", {
                staticClass: "icon-password",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _vm.website.validateCode
        ? _c(
            "el-form-item",
            { attrs: { prop: "code" } },
            [
              _c("Verify", {
                ref: "verify",
                attrs: {
                  mode: "pop",
                  "captcha-type": "blockPuzzle",
                  "img-size": { width: "330px", height: "155px" },
                },
                on: { success: _vm.verifySuccess },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              staticClass: "login-submit",
              attrs: { type: "primary", size: "small" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
            },
            [_vm._v("登录\n    ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "register-btn",
              attrs: { type: "add", size: "small" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleRegister.apply(null, arguments)
                },
              },
            },
            [_vm._v("注册\n    ")]
          ),
          _c(
            "span",
            { staticClass: "forgot-pwd", on: { click: _vm.forgotPassword } },
            [_vm._v("忘记密码？")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }